module.exports = __webpack_public_path__ + "static/img/community03.976966c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/community03.jpg
// module id = pFuu
// module chunks = 0